(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('userAddAction', {
      controller: Controller,
      templateUrl: 'actions/user/add/add-user.action.html',
      bindings: {
        credentials: '<',
        teamId: '<',
        user: '<',
        then: '&',
        catch: '&'
      }
    });
}());
